/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendActualSaleDto } from '../../models/backend-actual-sale-dto';

export interface MonitoringFactSalesList$Params {
  scenario_id: number;
}

export function monitoringFactSalesList(
  http: HttpClient,
  rootUrl: string,
  params: MonitoringFactSalesList$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<Array<BackendActualSaleDto>>> {
  const rb = new RequestBuilder(rootUrl, monitoringFactSalesList.PATH, 'get');
  if (params) {
    rb.path('scenario_id', params.scenario_id, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<Array<BackendActualSaleDto>>;
    }),
  );
}

monitoringFactSalesList.PATH = '/api/monitoring/fact/sales/{scenario_id}/';
